import { Component } from "@angular/core";

@Component({
  selector: 'page-content',
  template: `<ng-content>page-content</ng-content>`,
})
export class PageContentComponent {}